import { IModuleInitializerParams } from "@/Common/Modularity/ModuleInitializer";
import { ModuleInitializerBuilder } from "@/Common/Modularity/ModuleInitializerBuilder";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { ModuleNames } from "../ModuleNames";

function isFeatureFlagEnabled(params: IModuleInitializerParams): boolean {
    return params.clinicSettings.EnableOntarioDigitalHealthDrugRepository;
}

function isActiveSiteOntario(params: IModuleInitializerParams): boolean {
    return params.currentEmployee.getActiveSite().isSiteInProvince(CanadaState.Ontario);
}

function shouldLoadModule(params: IModuleInitializerParams): boolean {
    return isFeatureFlagEnabled(params) && isActiveSiteOntario(params);
}

const initializeDigitalHealthDrugRepository = new ModuleInitializerBuilder()
    .withConditionalLoading(shouldLoadModule)
    .build(ModuleNames.DigitalHealthDrugRepository, async () => (await import("./DigitalHealthDrugRepositoryModule")).default);

export default initializeDigitalHealthDrugRepository;
